/* eslint-disable react/display-name */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl } from '@material-ui/core';
import SelectControlled from './SelectControlled';
import {
  fontColors,
  backgroundColors,
  colorDanger,
  colorDefault,
} from '../../material-ui-theme';

// Form value pickup
// component: 'numeric-input'
// value: value

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    color: 'var(--color-fontColors-black)',
    '& .MuiFormControl-fullWidth': {
      minWidth: 155,
      height: 30,
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"]': {
      border: '1px solid',
      borderColor: 'var(--color-colorDefault-main)',
      borderRadius: 4,
      height: 30,
    },
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child':
      {
        paddingLeft: 6,
        paddingBottom: 7,
        cursor: 'pointer',
        '&::selection': { background: 'transparent' },
        '&::-moz-selection': { background: 'transparent' },
      },
  },
  inputPaper: {
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'var(--color-white)',
    borderRadius: 4,
    '& input': {
      padding: '6px 3px 6px 6px',
      margin: 0,
      fontSize: '0.9rem',
      fontWeight: 400,
      color: 'var(--color-fontColors-black)',
      borderRadius: 4,
      borderColor: colorDefault.main,
      height: 30,
      minWidth: 40,
      boxSizing: 'border-box',

      '&::placeholder': {
        opacity: '1',
        color: '#808080',
      },
    },
  },
  inputPaperDisabled: {
    backgroundColor: backgroundColors.disabled,
    padding: 0,
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    borderRadius: 4,
    '& input': {
      padding: '6px 3px 6px 6px',
      margin: 0,
      fontSize: '0.9rem',
      fontWeight: 400,
      color: fontColors.disabled,
      '-webkit-text-fill-color': fontColors.disabled,
      opacity: 1 /* required on iOS */,
      borderRadius: 4,
      borderColor: '#efefef',
      height: 30,
      minWidth: 40,
      boxSizing: 'border-box',

      '&::placeholder': {
        opacity: '1',
        color: '#808080',
      },
    },

    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child':
      {
        cursor: 'initial',
      },
  },
  helperText: {
    margin: 0,
    fontSize: '0.9rem',
    marginTop: '3px',
    textAlign: 'left',
    fontWeight: 500,
    color: colorDanger.main,
    paddingLeft: theme.spacing(1),
  },
}));

const FlatSelectControlled = memo(
  ({ error, helperText, disabled, ...restProps }) => {
    const classes = useStyles();

    return (
      <FormControl className={classes.inputRoot} error={error}>
        <div
          className={
            disabled
              ? `${classes.inputPaperDisabled} inputPaperDisabled-class`
              : classes.inputPaper
          }
          elevation={0}
        >
          <SelectControlled
            className={classes.input}
            disabled={disabled}
            {...restProps}
          />
        </div>
        {error && helperText !== '' ? (
          <p className={classes.helperText}>{helperText}</p>
        ) : null}
      </FormControl>
    );
  }
);

FlatSelectControlled.defaultProps = {
  error: false,
  helperText: '',
  disabled: false,
  width: '300px',
};

FlatSelectControlled.propTypes = {
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.string,
};

export default FlatSelectControlled;
